<template>
  <div>
    <cx-query-condition :loading="loading" @query="query"
                        @reset='resetQc'>
      <el-row>
        <el-col :span="5">
          <el-form-item label="姓名">
            <cx-input v-model="qc.list.name"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="员工类型">
            <cx-select v-model="qc.list.type_id" :options="employeeTypeList" />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="转正状态">
            <cx-select v-model="qc.list.regular_status" :options="regularTypeList" />
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="员工状态">
            <cx-select v-model="qc.list.status" :options="employeeStatusList" />
          </el-form-item>
        </el-col>
      </el-row>
    </cx-query-condition>

    <cx-dialog v-if='dialog.showDialog'
               :visible='dialog.showDialog'
               :title='dialog.title'
               :rules='dialog.rules'
               :model='dialog.model'
               width="70%"
               :showOkBtn="dialog.showOkBtn"
               @ok='save'
               @close='close'>
      <template v-if='dialog.title == TITLE.ADD'>
        <el-tabs v-model="dialog.activeName">
          <el-tab-pane label="个人信息" name="person">
            <el-row>
              <el-col :span="8">
                <el-form-item label="姓名" prop='name'>
                  <cx-input v-model='qc.add.name' />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="国籍">
                  <cx-select v-model="qc.add.country" :clearable='false'
                             :options="countryList" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别" prop='sex'>
                  <cx-radio :options='dialog.GENDER' v-model='qc.add.sex' />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="证件" prop='id_type_id'>
                  <cx-select v-model="qc.add.id_type_id" :clearable='false'
                             :options="idTypeList" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="证件号" prop='id_card'>
                  <cx-input v-model='qc.add.id_card'/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号" prop='phone'>
                  <cx-input v-model='qc.add.phone' />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="邮箱" prop='mail'>
                  <cx-input v-model='qc.add.mail' />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="户籍" prop='hold_nature'>
                  <cx-select v-model="qc.add.hold_nature"
                             :clearable='false'
                             :options="residenceTypeList" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- <el-form-item label="户口所在地">
                  <cx-cascader v-model="qc.add.residenceIdsArray" :options="residenceList"
                              :changeOnSelect="true" :clearable="false" />
                </el-form-item> -->
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="民族">
                  <cx-select v-model="qc.add.nation" :options="nationList" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="最高学历">
                  <cx-select v-model="qc.add.education" :options="educationList" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="服务项目" prop="function_list">
                  <cx-select :multiple="true" v-model="qc.add.function_list"
                             :options="CONST.PRODUCT_LIST" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="社保类型" prop='ss_type_id'>
                  <cx-select v-model="qc.add.ss_type_id" :options="ssTypeList" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="岗位信息" name="job">
            <el-row>
              <el-col :span="8">
                <el-form-item label="员工类型">
                  <cx-select v-model="qc.add.type_id"
                             :clearable='false'
                             :options="employeeTypeList" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="职位" prop='position'>
                  <cx-input v-model="qc.add.position"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="部门">
                  <cx-cascader v-model="qc.add.deptIdsArray" :options="deptList"
                              :changeOnSelect="true" :clearable="false" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="入职日期" prop='entry_date'>
                  <cx-date-picker v-model="qc.add.entry_date"
                                  :type="'date'"
                                  :format="'yyyy-MM-dd'"
                                  :valueFormat="'yyyy-MM-dd'"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="试用期">
                  <cx-select v-model='qc.add.probation' :style='{width:"40%"}' :clearable='false'
                             :options='probationList'/>&nbsp;&nbsp;&nbsp;&nbsp;个月
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="工作地点">
                  <cx-input v-model="qc.add.work_addr"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="直属上级">
                  <cx-input v-model="qc.add.supervisor"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="企业邮箱" prop='enterprise_mail'>
                  <cx-input v-model="qc.add.enterprise_mail"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="工号">
                  <cx-input v-model="qc.add.work_no"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="首次工作时间" prop='first_work'>
                  <cx-date-picker v-model="qc.add.first_work"
                                  :type="'date'"
                                  :format="'yyyy-MM-dd'"
                                  :valueFormat="'yyyy-MM-dd'"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="薪资信息" name="salary">
            <el-row>
              <el-col :span="8">
                <el-form-item label="基本工资">
                  <cx-input-number v-model='qc.add.base_pay'
                                  :min="null" :max="9999999" :precision="2" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="绩效工资">
                  <cx-input-number v-model='qc.add.merit_pay'
                                  :min="null" :max="9999999" :precision="2" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="工资卡号">
                  <cx-input v-model='qc.add.pay_card'/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="开户银行">
                  <cx-select v-model="qc.add.pay_card_addr" :options="bankList" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </template>

      <template v-else-if='dialog.title.indexOf(TITLE.DETAIL) != -1'>
        <el-tabs v-model="table.activeName">
          <el-tab-pane label="员工档案" name="file">
            <el-row>
              <el-col :span="8">
                <el-form-item label="工号">
                  {{ selectedRows[0].work_no }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="直属上级">
                  {{ selectedRows[0].supervisor }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="员工类型">
                  {{ selectedRows[0].type_name }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="入职日期">
                  {{ selectedRows[0].entry_date }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="实际转正日期">
                  {{ selectedRows[0].regular_date }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="个人邮箱">
                  {{ selectedRows[0].mail }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="福利保险" name="insurance">
            <el-row>
              <el-col :span="8">
                <el-form-item label="社保参保地">
                  {{ selectedRows[0].insured_area_s }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="社保基数">
                  {{ selectedRows[0].s_base }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="社保起始时间">
                  {{ selectedRows[0].begin_date_s }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="公积金参保地">
                  {{ selectedRows[0].insured_area_f }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="公积金基数">
                  {{ selectedRows[0].f_base }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="公积金起始时间">
                  {{ selectedRows[0].begin_date_f }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="人事流程" name="process">
            <el-row v-for='item in selectedRows[0].process'
                    :key='item.id'>
              <el-col :span="8">
                <el-row>
                  <el-col :span="6">
                    {{ formatFlowType(item.flow_type) }}
                  </el-col>
                  <el-col :span="6">
                    {{ formatRecordStatus(item.record_status) }}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </template>

      <template v-else-if='dialog.title == TITLE.REGULAR'>
        <el-row>
          <el-col :span="8">
            <el-form-item label="转正员工">
              {{ this.selectedRows[0].name }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="入职日期">
              {{ this.selectedRows[0].entry_date }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="试用期">
              {{ this.selectedRows[0].probation_name }} 个月
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="预计转正日期">
              {{ this.selectedRows[0].expecting_regular_date }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="实际转正日期">
              <cx-date-picker v-model="qc.process_add.effect_time"
                              :type="'date'"
                              :pickerOptions='dialog.disabledDate'
                              :clearable='false'
                              :format="'yyyy-MM-dd'"
                              :valueFormat="'yyyy-MM-dd'"/>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <template v-else-if='dialog.title == TITLE.QUIT'>
        <el-row>
          <el-col :span="8">
            <el-form-item label="离职员工">
              {{ selectedRows[0].name }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="离职原因" prop='reasonIdsArray'>
              <cx-cascader v-model="qc.process_add.reasonIdsArray"
                           :options="quitTypeList"
                           :changeOnSelect="true" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生效日期" prop='effect_time'>
              <cx-date-picker v-model="qc.process_add.effect_time"
                              :type="'date'"
                              :format="'yyyy-MM-dd'"
                              :valueFormat="'yyyy-MM-dd'"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="备注">
              <cx-text-area :rows='3' v-model='qc.process_add.comment'/>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <template v-else-if='dialog.title == TITLE.CHANGE'>
        <el-row>
          <el-col :span="8">
            <el-form-item label="变更员工">
              {{ selectedRows[0].name }}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="部门">
              <cx-cascader v-model="qc.process_add.deptIdsArray" :options="deptList"
                           :changeOnSelect="true" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职位">
              <cx-input v-model='qc.process_add.position'/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="员工类型">
              <cx-select v-model="qc.process_add.type_id"
                         :clearable='false'
                         :options='employeeTypeList'/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="直属上级">
              <cx-input v-model='qc.process_add.supervisor'/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="工作地点">
              <cx-input v-model='qc.process_add.work_addr'/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="生效日期" prop='effect_time'>
              <cx-date-picker v-model="qc.process_add.effect_time"
                              :type="'date'"
                              :format="'yyyy-MM-dd'"
                              :valueFormat="'yyyy-MM-dd'"/>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="备注">
              <cx-input v-model='qc.process_add.comment'/>
            </el-form-item>
          </el-col>
        </el-row>
      </template>

      <template v-else-if='dialog.title == TITLE.MODIFY'>
        <el-tabs v-model="dialog.activeName_1">
          <el-tab-pane label="基本信息" name="base">
            <el-row>
              <el-col :span="8">
                <el-form-item label="姓名">
                  {{ selectedRows[0].name }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="国籍">
                  <cx-select v-model="qc.modify.country" :options="countryList" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别">
                  {{ selectedRows[0].sex_name }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="证件类型">
                  {{ idTypeMap[selectedRows[0].id_type_id] }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="证件号">
                  {{ selectedRows[0].id_card }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="民族">
                  <cx-select v-model="qc.modify.nation" :options="nationList" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="生日">
                  {{ selectedRows[0].birthday }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机" prop='phone'>
                  <cx-input v-model='qc.modify.phone' />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="个人邮箱" prop='mail'>
                  <cx-input v-model='qc.modify.mail' />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="户口性质">
                  {{ selectedRows[0].hold_nature_name }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="户口所在地">
                  {{ selectedRows[0].addr }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="最高学历">
                  <cx-select v-model="qc.modify.education" :options="educationList" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="岗位信息" name="post">
            <el-row>
              <el-col :span="8">
                <el-form-item label="工号">
                  <cx-input v-model="qc.modify.work_no"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="企业邮箱" prop='enterprise_mail'>
                  <cx-input v-model="qc.modify.enterprise_mail"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="员工状态">
                  {{ selectedRows[0].regular_name }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="员工类型">
                  {{ selectedRows[0].type_name }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="部门">
                  {{ selectedRows[0].dept_name }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="职位">
                  {{ selectedRows[0].position }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="直属上级">
                  {{ selectedRows[0].supervisor }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="工作地点">
                  {{ selectedRows[0].work_addr }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="入职时间">
                  <cx-date-picker v-model="qc.modify.entry_date"
                                  :type="'date'"
                                  :format="'yyyy-MM-dd'"
                                  :valueFormat="'yyyy-MM-dd'"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
               
              <el-col :span="8">
                <el-form-item label="转正状态">
                  {{ selectedRows[0].regular_name }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="实际转正日期">
                  {{ selectedRows[0].regular_date }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="首次工作时间">
                  <cx-date-picker v-model="qc.modify.first_work"
                                  :type="'date'"
                                  :format="'yyyy-MM-dd'"
                                  :valueFormat="'yyyy-MM-dd'"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </template>

      <template v-else-if='dialog.title == TITLE.UPLOAD'>
        <el-row>
          <el-col :span="24">
            <cx-upload-files :fileList="dialog.fileList"
                             :action="CX_API_ROOT + '/client-employee/upload'"
                             :delUrl="CX_API_ROOT + '/client-employee/delete-file'"
                             :data="qc.upload"/>
          </el-col>
        </el-row>
      </template>
        
    </cx-dialog>

    <el-table v-loading="loading"
              :data="data"
              border
              highlight-page-row
              size='mini'
              style="width:100%"
              @selection-change='handleSelectionChange'>
      <el-table-column type="selection" width="50"/>
      <el-table-column type="index" label="序号" width="50" header-align="center" align="center"/>
      <el-table-column prop="name" label="员工" width="120"/>
      <el-table-column prop="type_name" label="员工类型" width="100"/>
      <el-table-column prop="sex_name" label="性别" width="100"/>
      <el-table-column prop="age" label="年龄" width="70"/>
      <el-table-column prop="work_no" label="工号" width="70"/>
      <el-table-column prop="dept_name" label="部门" width="100"/>
      <el-table-column prop="entry_date" label="入职时间" width="100"/>
      <el-table-column prop="regular_name" label="转正情况" width="100"/>
      <el-table-column prop="status_name" label="员工状态" width="100"/>
    </el-table>

    <cx-pagination :pageData="qc.list"
                   @sizeChange='query(false)'
                   @pageChange='query(false)' />
    
    <cx-btn-group>
      <el-button type="success" icon="el-icon-refresh"
                 size='mini' @click='query(false)'>刷新</el-button>
      <el-button type="primary" icon="el-icon-plus"
                 size='mini' @click='add'>新增</el-button>
      <el-button type="success" icon="el-icon-info"
                 size='mini' @click='detail'>详情</el-button>
      <el-button type="primary" icon="el-icon-check"
                 size='mini' @click='regular'>转正</el-button>
      <el-button type="primary" icon="el-icon-receiving"
                 size='mini' @click='change'>人事变更</el-button>
      <el-button type="primary" icon="el-icon-cpu"
                 size='mini' @click='quit'>离职</el-button>
      <el-button type="warning" icon="el-icon-edit"
                 size='mini' @click='modify'>编辑</el-button>
      <el-button type="danger" icon="el-icon-minus"
                 size='mini' @click='querySocialHistory(queryFundHistory(del))'>删除</el-button>
      <el-button type="success" icon="el-icon-upload2"
                 size='mini' @click='upload'>上传员工信息</el-button>
    </cx-btn-group>
  </div>
</template>

<script>
export default {
  data() {
    var checkCardId = (rule, value, callback) => { // 自定义身份证号码验证

      if (!this.CONST.REG_EXP.ID.test(value)) {
        callback(new Error());
        this.qc.add.sex = null;
        this.qc.add.birthday = null;

      } else {
        this.getBirthdayAndGenderFromID(value);
        callback();
      }
    };

    var checkCardId_1 = RE => { // 自定义其他证件号码验证
      return (rule, value, callback) => {
        if (!RE.test(value)) {
          callback(new Error());
        } else {
          callback();
        }
      }
    };

    var checkCardType = (rule, value, callback) => {
      if (value == this.dialog.ID_CARD_ID) { // 是身份证
        this.dialog.GENDER.forEach(item => {
          item.disabled = true;
        });
        this.qc.add.sex = null;
        this.dialog.rules.id_card[1].validator = checkCardId;
        // this.dialog.rules.sex[0].required = false;
        this.getBirthdayAndGenderFromID(this.qc.add.id_card);
        callback();
      } else { // 是其他证件
        setTimeout(() => {
          this.qc.add.sex = 2
        },100);
        this.dialog.GENDER.forEach(item => {
          item.disabled = false;
        });
        
        
        // this.dialog.rules.sex[0].required = true;
        this.dialog.rules.id_card[1].validator =
                    checkCardId_1(this.dialog.cardIdREMap[value])
        callback();
      }
    }

    return {
      loading: false,
      TITLE: { // dialog 的标题
        ADD: '新增员工',
        DETAIL: '员工详情',
        REGULAR: '员工转正',
        QUIT: '员工离职',
        CHANGE: '人事变更',
        MODIFY: '员工编辑',
        UPLOAD: '上传员工信息',
      },
      dialog: { // 关于 dialog 的各属性
        title: '加载中...',
        showDialog: false,
        rules: {
          name: [{required: true, trigger: 'blur', message: '请填写员工姓名'}],
          sex: [{required: false, trigger: 'blur', message: '请选择性别'}],
          id_type_id: [{ validator: checkCardType, trigger: 'change' }],
          id_card: [{ required: true, trigger: 'blur', message: '请填写证件号码' },
                    { validator: checkCardId, trigger: 'blur', message: '证件号码格式错误'}],
          // hold_nature: [{ required: true, message: '请填选择户籍性质' }],
          function_list: [{ required: true, trigger: 'blur', message: '请选择服务项目' }],
          ss_type_id: [{ required: true, trigger: 'blur', message: '请选择社保类型' }],
          entry_date: [{ required: true, trigger: 'blur', message: '请选择入职日期' }],
          phone: [{ required: true, pattern:this.CONST.REG_EXP.MOBILEPHONE, trigger: 'blur', message: '手机号码格式有误'}],
          mail: [{pattern:this.CONST.REG_EXP.EMAIL, trigger: 'blur', message: '邮箱地址格式有误'}],
          position: [{ required: true, trigger: 'blur', message: '请填写职位' }],
          // deptIdsArray: [{ required: true, trigger: 'blur', message: '请选择部门' }],
          enterprise_mail: [{pattern:this.CONST.REG_EXP.EMAIL, trigger: 'blur', message: '邮箱地址格式有误'}],
          reasonIdsArray: [{ required: true, trigger: 'change', message: '请填写离职原因' }],
          first_work: [{ required: true, trigger: 'change', message: '请选择首次参加工作日期' }],
          effect_time: [{ required: true, trigger: 'change', message: '请选择生效日期' }],
        },
        activeName: 'person',
        activeName_1: 'base',
        model: null,
        GENDER: this.CONST.SEX,
        ID_CARD_ID: null, // 身份证的 id
        cardIdREMap: {}, // 验证不同证件号的正则规则映射
        header: {
          // "token": this.$store.state.token,
          "Content-Type": "multipart/form-data"
        },
        disabledDate: time => { // 定义 detepicker 中的无效日期的方法
          // return time.getTime() < new Date(this.selectedRows[0].entry_date)
          return true;
        },
        showOkBtn: true,
      },
      table: { // 关于 table 的属性
        activeName: 'file' // 默认 tab: 员工档案
      },
      flag: {
        isDeptReady: false,
      },
      selectedRows: [],
      deptList: [],
      deptMap: {},
      countryList: [], // 国籍列表
      countryMap: {}, // 国籍映射
      idTypeList: [], // 证件列表
      idTypeMap: {}, // 证件映射
      residenceTypeList: [], // 户籍性质列表
      residenceTypeMap: {}, // 户籍性质映射
      residenceList: [], // 户籍所在地列表
      nationList: [], // 民族列表
      nationMap: {}, // 民族映射,key为id，值为name
      nationNameMap: {}, // 民族映射,key为name，值为id
      educationList: [], // 学历列表
      employeeTypeList: [], // 员工类型
      bankList: [], // 银行列表
      bankMap: {}, // 银行映射
      regularTypeList: [], // 转正状态
      employeeStatusList: [], // 员工状态
      ssTypeList: this.CONST.SS_TYPE, // 社保类型
      probationList: [], // 试用期
      probationMap: {}, // 试用期映射
      quitTypeList: [], // 离职类型
      quitReasonList1: [], // 主动离职原因
      quitReasonList2: [], // 被动离职原因
      List: [], // 证件列表
      URL: { // 各请求接口
        LIST: '/client-employee/list',
        ADD: '/client-employee/add',
        // SOCIAL: '/social/overview', // 查询员工社保
        // FUND: '/fund/overview', // 查询员工公积金
        SOCIAL_HISTORY: '/social/history',
        FUND_HISTORY: '/fund/history',
        PROCESS: '/changes/list', // 查询人事流程
        MODIFY: '/client-employee/modify',
        PROCESS_ADD: '/changes/add', // 提交人事流程
        UPLOAD: '/client-employee/upload',
        DELETE_FILE: '/client-employee/delete-file',
        FILE_LIST: '/file/hr-emp-list',
        DICT: '/sys-dictionaries/list',
        DEPT: '/client-dept/list',
      },
      qc: { // 各查询参数
        list: { // 员工列表
          name: null,
          type_id: null, // 员工类型
          regular_status: null, // 转正状态
          status: null, // 员工状态

          total: this.CONST.PAGINATION.TOTAL,
          page: this.CONST.PAGINATION.PAGE,
          rows: this.CONST.PAGINATION.ROWS,
        },
        dict: { // 字典
          rows: 99999,
        },
        add: { // 添加员工
          name: null,
          country: null, // 国籍
          id_type_id: null, // 证件类型
          id_card: null, // 证件号
          birthday: null,
          sex: null,
          age: null,
          phone: null,
          mail: null,
          hold_nature: null, // 户口性质
          residenceIdsArray: null, // 户口所在地级联列表
          addr: null, // 户口所在地
          nation: null, // 民族
          education: null, // 最高学历
          function_list: null,
          function_ids: null, // 服务项目
          ss_type_id: null, // 社保类型
          type_id: null, // 员工类型
          position: null, // 职位
          deptIdsArray: null, // 部门级联列表
          dept_id: null,
          entry_date: null, // 入职时间
          regular_status: null, // 转正状态
          probation: null, // 试用期月数
          work_addr: null, // 工作地点
          supervisor: null, // 直属上级
          enterprise_mail: null, // 企业邮箱
          work_no: null, // 工号
          first_work: null, // 首份工作时间
          base_pay: null, // 基本工资
          merit_pay: null, // 绩效工资
          pay_card: null, // 工资卡号
          pay_card_addr: null, // 工资开户行
        },
        change: { // 人事变更
          id: null,
          dept_id: null,
          deptIdsArray: null,
          position: null, // 职位
          type_id: null, // 员工类型
          supervisor: null, // 直属上级
          work_addr: null, // 工作地点
          effect_time: null, // 生效日期
          comment: null // 备注
        },
        process_add: {  // 提交人事流程
          id: null,
          flow_type: null,
          record_status: null,
          effect_time: null,
        },
        regular: {
          id: null,
        },
        modify: { // 编辑
          id: null,
          name: null,
          country: null, // 国籍
          id_type_id: null, // 证件类型
          nation: null, // 民族
          phone: null,
          mail: null,
          education: null, // 最高学历

          code: null, // 工号
          company_mail: null, // 企业邮箱
          in_date: null, // 入职时间
          first_job_date: null, // 首次工作时间

          regular_date: null, // 转正日期
        },
        delete: {
          ids: null
        },
        upload: {
          id: null
        },
        social: { // 查社保
          id: null
        },
        fund: { // 查公积金
          id: null
        },
        process: { // 查公人事流程
          emp_id: null
        },
      },
      data: null,
      // save: null // 保存 dialog 时执行的方法
    }
  },
  methods: {
    formatFlowType(flow_type) {
      var obj = this.CONST.HR_PROCESS_TYPE.filter(item => item.id == flow_type);
      return obj[0].name;
    },
    formatRecordStatus(record_status) {
      var obj = this.CONST.HR_PROCESS_STATUS.filter(item => item.id == record_status);
      return obj[0].name;
    },
    query(isInit) { // isInit 判断是否是一进页面就查询
      this.loading = true;

      let justQueryList = () => {
        var qc = this._.cloneDeep(this.qc.list);

        if (!qc.type_id) {
          qc.type_id = null;
        }
        if (!qc.regular_status) {
          qc.regular_status = null;
        }
        if (!qc.status) {
          qc.status = null;
        }
        

        this.post(this.URL.LIST, qc).then(
          res => {
            this.loading = false;

            if (res) {
              if (res.data.success) {
                if (!res.data.rows) {
                  this.data = res.data.rows;
                  this.qc.list.total = res.data.total;
                  return;
                }

                var STATUS = this.CONST.EMPLOYEE_STATUS
                var isDeptReady = false;

                res.data.rows.forEach(row => {
                  row.social = {};
                  row.fund = {};
                  row.process = {};

                  if (row.regular_date && row.regular_date[0] == '0') {
                    row.regular_date = null;
                  }
                  if (row.turnover_date && row.turnover_date[0] == '0') {
                    row.turnover_date = null;
                  }

                  if (!row.type_id) {
                    row.type_id = null;
                  }

                  if (row.country) {
                    var list = this.countryList;
                    for (var i = 0; i < list.length; i++) {
                      if (list[i].name == row.country) {
                        row.country = list[i].id;
                        break;
                      }
                    }
                  }
                  if (row.nation) {
                    row.nation = this.nationNameMap[row.nation];
                  }
                  if (row.education) {
                    row.education = Number(row.education);
                  } else {
                    row.education = null;
                  }

                  row.sex_name = row.sex == 1? '男': '女';

                  for (var i = 0; i < this.CONST.EMPLOYEE_STATUS.length; i++) {
                    if (STATUS[i].id == row.status) {
                      row.status_name = STATUS[i].name;
                      break;
                    }
                  }

                  row.hold_nature_name = this.residenceTypeMap[row.hold_nature];

                  for (var i = 0; i < this.employeeTypeList.length; i++) {
                    if (this.employeeTypeList[i].id == row.type_id) {
                      row.type_name = this.employeeTypeList[i].name;
                      break;
                    }
                  }

                  // 如果提供了身份证号，自动计算年龄
                  if (this.CONST.REG_EXP.ID.test(row.id_card)) {
                    var birth_year = row.id_card.substring(6, 10);
                    var now_year = new Date().getFullYear();
                    row.age = now_year - birth_year;
                  }
                  
                  if (row.dept_id) {
                    row.dept_name = this.deptMap[row.dept_id];
                  }

                  if (row.regular_status) {
                    row.regular_name = row.regular_status == 1? '已转正' : '试用期';
                  }

                  if (row.probation) {
                    row.probation_name = this.probationMap[row.probation]
                    if (row.regular_status != 1 && row.entry_date) { // 如果还在试用期，需要计算预计转正日期
                      
                      var date_list = row.entry_date.split('-');
                      date_list[1] = Number(date_list[1]) + Number(row.probation_name);
                      if (date_list[1] > 12) {
                        date_list[1] = '0' + date_list[1] % 12;
                        date_list[0] = Number(date_list[0]) + 1;
                      }
                      row.expecting_regular_date = date_list.join('-');
                    }
                  }
                });

                this.data = res.data.rows;
                this.qc.list.total = res.data.total;
              }
            }
          }
        );
      }

      if (isInit) {
        this.all([
          this.ax.post(this.URL.DEPT, {})
        ]).then(this.axios.spread((deptRes) => {
          
          if (deptRes) {
            if (deptRes.data.success) {

              this.deptMap = {};
              this.deptList = deptRes.data.rows;

              var findChildren = data => {
                for (var i = 0; i < data.length; i++) {
                  this.deptMap[data[i].id] = data[i].label || data[i].name;
                  if (data[i].children) {
                    findChildren(data[i].children);
                  }
                }
              }

              findChildren(deptRes.data.rows);
            }
          }

          justQueryList();
            
        }));
      } else {

        justQueryList();
      }
      
    },
    // querySocial(row) {
    //   this.qc.social.id = row.id;
    //   var qc = this._.cloneDeep(this.qc.social);
    //   this.post(this.URL.SOCIAL, qc).then(
    //     res => {
    //       if (res) {
    //         if (res.data.success) {
    //           if (res.data.rows) {
    //             row.social = res.data.rows[0];
    //           }
    //         }
    //       }
    //     }
    //   )
    // },
    // queryFunc(row) {
    //   this.qc.fund.id = row.id;
    //   var qc = this._.cloneDeep(this.qc.fund);
    //   this.post(this.URL.FUND, qc).then(
    //     res => {
    //       if (res) {
    //         if (res.data.success) {
    //           if (res.data.rows) {
    //             row.fund = res.data.rows[0];
    //           }
    //         }
    //       }
    //     }
    //   )
    // },
    queryProcess(row) {
      this.qc.process.emp_id = row.id;
      var qc = this._.cloneDeep(this.qc.process);
      this.post(this.URL.PROCESS, qc).then(
        res => {
          if (res) {
            if (res.data.success) {
              row.process = res.data.rows;
            }
          }
        }
      )
    },
    querySocialHistory(callback) {
      var rows = this.selectedRows;
      if (rows.length) {
        var postList = '[';
        rows.forEach(row => {
          postList += 'this.ax.post(this.URL.SOCIAL_HISTORY, {id:' + row.id + '}),';
        });
        postList += ']';
        this.all(eval(postList)).then(this.axios.spread((...r) => { // 查社保记录
          r.forEach((item, ind) => {
            if (item.data.rows && item.data.rows.length) {
            // if (!item.rows || !item.rows.length) {
              this.error('有员工存在社保记录，无法删除');
              return;
            } else {
              if (callback) {
                callback();
              }
            }
          })
        }));
      } else {
        this.warning(this.CONST.TIP_INFO.SELECT_TRS)
      }
    },
    queryFundHistory(callback) {

      var rows = this.selectedRows;

      var postList = '[';
      rows.forEach(row => {
        postList += 'this.ax.post(this.URL.FUND_HISTORY, {id:' + row.id + '}),';
      });
      postList += ']';

      this.all(eval(postList)).then(this.axios.spread((...r) => { // 查公积金记录
        r.forEach((item, ind) => {
          if (item.data.rows && item.data.rows.length) {
          // if (!item.rows && !item.rows.length) {
            this.error('有员工存在公积金记录，无法删除');
            return;
          } else {
            if (callback) {
              callback();
            }
          }
        })
      }));
    },
    handleIdChange(val) {
      this.getBirthdayAndGenderFromID(val)
    },
    getBirthdayAndGenderFromID(val) {
      if (!val) {
        return;
      }
      var birthday = val.substr(6,8);
      birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");
      this.qc.add.birthday = birthday

      var getBirthday = new Date(birthday.replace(/-/g, "\/")); 
      var nowDate = new Date(); 
      var age = nowDate.getFullYear() - getBirthday.getFullYear() -
                ((nowDate.getMonth() < getBirthday.getMonth() ||
                  nowDate.getMonth() == getBirthday.getMonth() &&
                  nowDate.getDate()<getBirthday.getDate())?1:0);
      this.qc.add.age = age.toString();

      var n = parseInt(val.substr(16, 1))
      
      if (n % 2 == 1) {
        this.qc.add.sex = 1
      } else {
        this.qc.add.sex = 2
      }
    },
    getAgeAndSeniorityFromID() {
      var birthday = this.form.birthday;
      var getBirthday = new Date(birthday.replace(/-/g, "\/")); 
      var nowDate = new Date(); 
      var age = nowDate.getFullYear()-getBirthday.getFullYear()-((nowDate.getMonth()<getBirthday.getMonth()|| nowDate.getMonth()==getBirthday.getMonth() && nowDate.getDate()<getBirthday.getDate())?1:0);
      this.form.age = age.toString();

    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    add() {
      this.close = () => {
        this.closeCommon();
      };
      
      this.save = () => {
        this.qc.add.status = 1;
        this.qc.add.regular_status = 2;
        var qc = this._.cloneDeep(this.qc.add);
        qc.function_ids = qc.function_list.join(',');
        if (qc.hold_nature) {
          qc.hold_nature = this.residenceTypeMap[qc.hold_nature];
        }
        if (qc.country) {
          qc.country = this.countryMap[qc.country];
        }
        if (qc.nation) {
          qc.nation = this.nationMap[qc.nation];
        }
        if (qc.pay_card_addr) {
          qc.pay_card_addr = String(qc.pay_card_addr);
        }
        
        
        if (qc.deptIdsArray) {
          qc.dept_id = qc.deptIdsArray.reverse()[0];
        }

        this.post(this.URL.ADD, qc).then(
          res => {
            if (res) {
              if (res.data.success) {
                this.close();
                this.success(res.data.msg);
                this.qc.list.page = 1;
                this.query();
              }
            }
          }
        )
      }
      
      this.dialog.showOkBtn = true;
      this.dialog.title = this.TITLE.ADD;
      this.dialog.model = this.qc.add;
      this.dialog.showDialog = true;
    },
    detail() {
      if (this.selectedRows.length == 1) {
        this.close = () => {
          this.closeCommon();
        };

        this.dialog.showOkBtn = false;
        var row = this.selectedRows[0]
        this.dialog.title =
          this.TITLE.DETAIL + ' : ' + row.name;

        // this.querySocial(row);
        // this.queryFunc(row);
        this.queryProcess(row);
        

        this.save = () => {
          this.dialog.showDialog = false;
        };
        this.dialog.showDialog = true;
      } else {
        this.warning(this.CONST.TIP_INFO.SELECT_SINGLE_TR)
      }
    },
    regular() { // 转正，这里只是提交转正申请，并不是真的转正
      if (this.selectedRows.length == 1) {
        this.close = () => {
          this.closeCommon();
        };

        if (this.selectedRows[0].regular_status == 1) { // 已转正
          this.error('请选择未转正的员工');
        } else {
          var date = new Date();
          this.qc.process_add = {};
          this.qc.process_add.effect_time =
            this.selectedRows[0].expecting_regular_date;
          // this.qc.modify.regular_date = // 转正日期默认为当前日期
          //   date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
          this.dialog.showOkBtn = true;
          this.dialog.title = this.TITLE.REGULAR;
          this.dialog.model = this.qc.regular;
          this.dialog.showDialog = true;
          
          this.save = () => {
            this.qc.process_add.emp_id = this.selectedRows[0].id;
            this.qc.process_add.flow_type = 1;
            this.qc.process_add.record_status = 2;

            var qc = this._.cloneDeep(this.qc.process_add);
             
            this.post(this.URL.PROCESS_ADD, qc).then(
              res => {
                if (res) {
                  if (res.data.success) {
                    this.dialog.showDialog = false;
                    this.success(res.data.msg);
                  }
                }
              }
            )
          };
        }
      } else {
        this.warning(this.CONST.TIP_INFO.SELECT_SINGLE_TR)
      }
    },
    quit() {
      if (this.selectedRows.length == 1) {
        this.close = () => {
          this.closeCommon();
        };

        this.dialog.showOkBtn = true;
        var row = this.selectedRows[0];
        
        if (row.status == 2) { // 已离职
           this.error('请选择未离职的员工');
        } else {
          this.qc.process_add = {};
          this.dialog.title = this.TITLE.QUIT;
          this.dialog.model = this.qc.process_add;
          this.dialog.showDialog = true;

          this.save = () => {
            this.confirm(
              '确认对该员工进行离职操作么？（离职执行后该员工未完成的工单以及人事流程将被撤销！）' +
              '<span style="color:red">离职操作只代表劳动关系结束，若要社保公积金减员请务必去做相应操作，否则无法减员！</span>',
              () => {
              this.qc.process_add.emp_id = this.selectedRows[0].id;
              this.qc.process_add.flow_type = 3;
              this.qc.process_add.record_status = 2;
              this.qc.process_add.leave_type =
                this.qc.process_add.reasonIdsArray[0];
              this.qc.process_add.leave_reason =
                this.qc.process_add.reasonIdsArray[1];

              var qc = this._.cloneDeep(this.qc.process_add);
              
              this.post(this.URL.PROCESS_ADD, qc).then(
                res => {
                  if (res) {
                    if (res.data.success) {
                      this.dialog.showDialog = false;
                      this.success(res.data.msg);
                    }
                  }
                }
              )
            });
            
          };
        }
      } else {
        this.warning(this.CONST.TIP_INFO.SELECT_SINGLE_TR);
      }
    },
    change() { // 人事变更
      if (this.selectedRows.length == 1) {
        this.close = () => {
          this.closeCommon();
        };

        var row = this.selectedRows[0];
        if (row.status == 2) { // 离职
          this.warning('请选择未离职的员工');
          return;
        }

        this.qc.process_add = {};
        this.qc.process_add = this._.cloneDeep(this.selectedRows[0]);
        this.qc.process_add.deptIdsArray = [this.selectedRows[0].dept_id];

        this.dialog.title = this.TITLE.CHANGE;
        this.dialog.model = this.qc.process_add;
        this.dialog.showOkBtn = true;
        this.dialog.showDialog = true;

        this.save = () => {
          this.qc.process_add.dept_id =
            this.qc.process_add.deptIdsArray[this.qc.process_add.deptIdsArray.length - 1];
          this.qc.process_add.emp_id = this.selectedRows[0].id;
          this.qc.process_add.flow_type = 2;
          this.qc.process_add.record_status = 2;


          var qc = this._.cloneDeep(this.qc.process_add);
            
          this.post(this.URL.PROCESS_ADD, qc).then(
            res => {
              if (res) {
                if (res.data.success) {
                  this.dialog.showDialog = false;
                  this.success(res.data.msg);
                  // this.qc.list.page = 1;
                  // this.query();
                }
              }
            }
          )
        };
      } else {
        this.warning(this.CONST.TIP_INFO.SELECT_SINGLE_TR)
      }
    },
    modify() { // 编辑
      if (this.selectedRows.length == 1) {
        this.close = () => {
          this.closeCommon();
        };

        this.qc.modify = this._.cloneDeep(this.selectedRows[0]);
        this.dialog.title = this.TITLE.MODIFY;
        this.dialog.model = this.qc.modify;
        this.dialog.showOkBtn = true;
        this.dialog.showDialog = true;

        this.save = () => {
          var qc = this._.cloneDeep(this.qc.modify);
          qc.nation = this.nationMap[qc.nation];
          qc.country = this.countryMap[qc.country];
          this.post(this.URL.MODIFY, qc).then(
            res => {
              if (res) {
                if (res.data.success) {
                  this.dialog.showDialog = false;
                  this.success(res.data.msg);
                  this.qc.list.page = 1;
                  this.query();
                }
              }
            }
          )
        };
      } else {
        this.warning(this.CONST.TIP_INFO.SELECT_SINGLE_TR)
      }
    },
    del() {
      var rows = this.selectedRows;
      var id_list = [];
      var name_list = [];
      rows.forEach(row => {
        id_list.push(row.id);
        name_list.push(row.name);
      });
      var names = name_list.join(', ');
      names = '【 ' + names + ' 】';
      this.qc.delete.ids = id_list.join(',');

      this.confirm('是否确定删除员工：' + names + '?此操作不可恢复！', () => {
        this.post('/client-employee/delete', this.qc.delete).then(res => {
          if (res) {
            if (res.data.success) {
              this.dialog.showDialog = false;
              this.success(res.data.msg);
              this.qc.list.page = 1;
              this.query();
            }
          }
        });
      });
    },
    upload() { // 上传文件
      if (this.selectedRows.length == 1) {
        this.dialog.fileList = [];
        var row = this.selectedRows[0]
        this.qc.upload.id = row.id;

        this.dialog.title = this.TITLE.UPLOAD;
        this.dialog.model = this.qc.upload;
        this.dialog.showOkBtn = false;

        if (row.file_ids) {
          this.post('/file/hr-emp-list', {
            ids: row.file_ids.toString()
          }).then(
            res => {
              if (res) {
                if (res.data.success) {
                  this.dialog.fileList = res.data['rows'] || [];
                  
                  this.dialog.showDialog = true;
                }
              }
            }
          )
        } else {
          this.dialog.showDialog = true;
        }

        this.close = () => {
          this.closeCommon();
          this.qc.list.page = 1;
          this.query();
        };
      } else {
        this.warning(this.CONST.TIP_INFO.SELECT_SINGLE_TR)
      }
    },
    
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    save() {
      // this.dialog.showDialog = false;
    },
    closeCommon() {
      this.dialog.showDialog = false;
      this.dialog.activeName = 'person';
      this.dialog.activeName_1 = 'base';
      this.table.activeName = 'file';
      this.qc.add = {
        sex: null,
        id_type_id: this.idTypeList[0].id,
        country: this.countryList[0].id,
        nation: this.nationList[0].id,
        education: this.educationList[0].id,
        type_id: this.employeeTypeList[0].id,
        probation: this.probationList[3].id,
        hold_nature: this.residenceTypeList[0].id
      }; 
      this.dialog.GENDER.forEach(item => {
        item.disabled = true;
      });
    },
    close() {
      this.closeCommon();
    },
    resetQc() {
      this.qc.list.name = null;
      this.qc.list.type_id = null;
      this.qc.list.regular_status = null;
      this.qc.list.status = null;
    },
  },
  mounted() {
    this.dialog.GENDER.forEach(item => {
      item.disabled = true;
    });
    this.query(true);
    
    let dictList = this.$store.state.common.dictList;
    dictList.forEach(row => {
      switch(row.type) {
        case 28: // 国籍
          this.countryList.push(row);
          this.countryMap[row.id] = row.name;
          if (row.ord == 1) { // 默认中国
            this.qc.add.country = row.id;
          }
          break;
        case 29: // 证件
          this.idTypeList.push(row);
          this.idTypeMap[row.id] = row.name;
          if (row.name === '身份证') {
            this.dialog.ID_CARD_ID = row.id;
            this.qc.add.id_type_id = row.id;
          } else {
            if (row.name.indexOf('护照') != -1) {
              this.dialog.cardIdREMap[row.id] =
                  new RegExp("(^([PpSsEe]{1}\\d{7}|[GgSs]{1}\\d{8})$)");
            } else if (row.name.indexOf('回乡') != -1) {
              this.dialog.cardIdREMap[row.id] = /.*/;
            } else if (row.name.indexOf('台胞') != -1) {
              this.dialog.cardIdREMap[row.id] = /.*/;
            }
          }
          break;
        case 16: // 户籍
          this.residenceTypeList.push(row);
          this.residenceTypeMap[row.id] = row.name;
          if (row.ord == 1) { // 默认选中第一个
            this.qc.add.hold_nature = row.id;
          }
          break;
        case 27: // 民族
          this.nationList.push(row);
          this.nationMap[row.id] = row.name;
          this.nationNameMap[row.name] = row.id;
          if (row.ord == 1) {
            this.qc.add.nation = row.id;
          }
          break;
        case 30: // 学历
          this.educationList.push(row);
          if (row.ord == 1) {
            this.qc.add.education = row.id;
          }
          break;
        case 31: // 员工类型
          this.employeeTypeList.push(row);
          if (row.ord == 1) {
            this.qc.add.type_id = row.id;
          }
          break;
        case 32: // 银行
          this.bankList.push(row);
          this.bankMap[row.id] = row.name;
          break;
        case 33: // 转正状态
          this.regularTypeList.push(row);
          break;
        case 34: // 员工状态
          this.employeeStatusList.push(row);
          break;
        // case 40: // 社保类型
        //   this.ssTypeList.push(row);
        //   break;
        case 47: // 试用期
          this.probationList.push(row);
          this.probationMap[row.id] = Number(row.name);
          if (row.ord == 4) {
            this.qc.add.probation = row.id;
          }
          break;
        case 49: // 离职类型
          row.label = row.name;
          this.quitTypeList.push(row);
          break;
        case 50: // 主动离职原因
          row.label = row.name;
          this.quitReasonList1.push(row);
          break;
        case 51: // 被动离职原因
          row.label = row.name;
          this.quitReasonList2.push(row);
          break;
      }
    });

    this.quitTypeList.forEach(type => {
      type.label = type.name;
      type.children = [];
    });

    this.quitReasonList1.forEach(reason => {
      reason.label = reason.name;
      this.quitTypeList[0].children.push(reason);
    });

    this.quitReasonList2.forEach(reason => {
      reason.label = reason.name;
      this.quitTypeList[1].children.push(reason);
    });

    this.residenceList = this.CONST.PROVINCE_CITY;

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/web/human_affairs/employee/list.vue